export default {
   bankDetails: {
     bank: '',
     accountNumber: '',
     clabe: ''
   }
}
